import React, { useEffect, useRef, useState } from "react"
import { DadosItemSelecao } from "./DadosItemSelecao"
import { ItemSelecao } from "./ItemSelecao"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCaretDown } from "@fortawesome/free-solid-svg-icons/faCaretDown";
import { faCaretUp } from "@fortawesome/free-solid-svg-icons/faCaretUp";
import { faCircleXmark } from "@fortawesome/free-solid-svg-icons/faCircleXmark";
import clsx from "clsx";
import * as R from 'ramda'

const estilosInputs = require('../../estilos/inputs.module.scss').default

export type SelecaoComFiltroProps = {
    itens: DadosItemSelecao[]
    onItemSelecionado: (chave: DadosItemSelecao) => void
    onValorModificado?: (valor: string) => void
    onLimpar?: () => void
    disabled?: boolean
    itemSelecionado?: DadosItemSelecao
    placeholder?: string
    classNameIconeSeta?: string
    exibirIconeLimpar?: boolean
    classNameInput?: string
    filtroManual?: boolean
    id?: string
}

export const SelecaoComFiltro = (props: SelecaoComFiltroProps) => {

    const [filtro, setFiltro] = useState(props.itemSelecionado?.valor ?? "")
    const [mostrarItens, setMostrarItens] = useState(false)
    const [ignorarFiltro, setIgnorarFiltro] = useState(false)
    const divPrincipalRef = useRef(null)
    const filtroRef = useRef(null)
    const containerRef = useRef<HTMLDivElement>(null);

    const filtrar = (item: DadosItemSelecao) => {
        return (ignorarFiltro || props.filtroManual) ? true : item.valor.toLowerCase().includes(filtro.toLowerCase())
    }

    const selecionarItem = (e: React.KeyboardEvent<HTMLInputElement>) => {
        const itemsFiltrados = props.itens.filter(filtrar);

        const indexAtual = itemsFiltrados.findIndex((item) => item.valor === filtroRef?.current?.value);
        if (indexAtual !== -1) {
            let novoIndex = indexAtual;
            if (e.key === "ArrowDown" && indexAtual < itemsFiltrados.length - 1) {
                novoIndex++;
            } else if (e.key === "ArrowUp" && indexAtual > 0) {
                novoIndex--;
            }
            setFiltro(itemsFiltrados[novoIndex].valor);
        } else if (itemsFiltrados.length > 0) {
            setFiltro(itemsFiltrados[0].valor);
        }
    };

    const iconeSetaPraBaixo = <>{!props.disabled &&
        <FontAwesomeIcon
            cursor={"pointer"}
            id={props.id ?  `${props.id}_IconeSetaPraBaixo` : undefined}
            key={props.id ?  `${props.id}_IconeSetaPraBaixo` : undefined}
            className={clsx(props.classNameIconeSeta, "material-icons")}
            icon={faCaretDown}
            style={{
                marginLeft: "-20px"
            }}
            onClick={() => {
                setMostrarItens(mostrarItens => !mostrarItens)
                setIgnorarFiltro(true)
            }}
        />
    }</>

    const iconeSetaPraCima = <FontAwesomeIcon
        cursor={"pointer"}
        id={props.id ?  `${props.id}_IconeSetaPraCima` : undefined}
        key={props.id ?  `${props.id}_IconeSetaPraCima` : undefined}
        className={clsx(props.classNameIconeSeta, "material-icons")}
        icon={faCaretUp}
        style={{
            marginLeft: "-20px",
            marginTop: "3px"
        }}
        onClick={() => {
            setMostrarItens(mostrarItens => !mostrarItens)
            setIgnorarFiltro(true)
        }}
    />

    const iconeExcLuir = <FontAwesomeIcon
        className="material-icons _ml-4 _text-[#f25713] _w-[18px] _cursor-pointer"
        key={props.id ?  `${props.id}_IconeExcluir` : undefined}
        id={props.id ?  `${props.id}_IconeExcluir` : undefined}
        icon={faCircleXmark}
        onClick={() => {
            props.onLimpar()
            setFiltro("")
        }}
    />


    const inputFiltro = <div className="_flex _flex-row ">
        <input
            ref={filtroRef}
            id={props.id ?  `${props.id}_SelecionaComFiltro_Input` : undefined}
            key={props.id ?  `${props.id}_SelecionaComFiltro_Input` : undefined}
            autoComplete="off"
            placeholder={props.placeholder ?? ""}
            disabled={props.disabled}
            className={clsx(estilosInputs.inputPadrao, "_w-full", props.classNameInput)}
            style={{
                height: "30px",
                paddingRight: "20px"
            }}
            value={(filtro) ?? ""}
            onFocus={() => {
                if (filtroRef.current) {
                    filtroRef.current.select()
                    }
                }
            }
            onChange={e => {
                setIgnorarFiltro(false)
                setMostrarItens(true)
                setFiltro(e.target.value)
                if (props.itemSelecionado){
                    props.onValorModificado(e.target.value)
                }
            }}
            onClick={() => {
                if (mostrarItens == false) {
                    setIgnorarFiltro(true)
                }

                setMostrarItens(true)
            }}
            onKeyDown={e => {
                if (R.includes(e.code, ["Enter", "NumpadEnter", "ArrowDown", "ArrowUp"])) {
                    e.preventDefault();
                    if (["ArrowDown", "ArrowUp"].includes(e.code)) {
                        setMostrarItens(true)
                        selecionarItem(e);
                    } else if (["Enter", "NumpadEnter"].includes(e.code)) {
                        const indexAtual = props.itens.findIndex((item) => item.valor === filtro)
                         if (indexAtual !== -1) {
                                props.onItemSelecionado(props.itens[indexAtual])
                        }
                        setFiltro(filtro)
                        setMostrarItens(false)
                    }else {
                        setFiltro(filtro)
                        setMostrarItens(false)
                    }
                }
            }}
        />

        {mostrarItens ? iconeSetaPraCima : iconeSetaPraBaixo}
    </div>

    const selecaoItens = (
        <div
            className="_overflow-y-scroll _absolute _z-50"
            style={{
                maxHeight: "20vh",
                width: filtroRef?.current?.clientWidth ?? "99vw",
                marginTop: "30px"
            }}
            ref={containerRef}
        >
            {props.itens
                .filter(filtrar)
                .map((item) => (
                    <ItemSelecao
                        containerRef={containerRef.current}
                        key={item.chave}
                        item={item}
                        id={props.id}
                        onItemSelecionado={() => {
                            setFiltro(item.valor)
                            setMostrarItens(false)
                            props.onItemSelecionado(item)
                        }}
                        isSelecionado={item.valor === filtro}
                    />
                ))}
        </div>
    );


    useEffect(() => {
        const handleCliqueForaDoElemento = (e) => {
            if (!(divPrincipalRef?.current?.contains?.(e.target) ?? false) && mostrarItens) {
                setMostrarItens(false)
            }
        }

        document.addEventListener("click", handleCliqueForaDoElemento)

        return () => document.removeEventListener("click", handleCliqueForaDoElemento)
    }, [divPrincipalRef, mostrarItens])

    useEffect(() => {
        setFiltro(props.itemSelecionado?.valor ?? "")
 
    }, [props.itemSelecionado?.chave])

    return <>
        <div className="_flex _flex-col _gap-1 " ref={divPrincipalRef} >
            {inputFiltro}

            {mostrarItens && selecaoItens}
        </div>

        {props.exibirIconeLimpar &&
            <div>
                {iconeExcLuir}
            </div>
        }
    </>
}
